import { z } from 'zod';

export const salonStatusSchema = z.enum(['Planifié', 'Active', 'Inactive', 'Terminé']);
export const salonTypeSchema = z.enum(['BtoB', 'BtoC', 'Les 2']);

export const salonSchema = z.object({
  id: z.string().uuid().optional(),
  regionId: z.string().uuid(),
  slotNumber: z.number().int().min(1).max(2),
  name: z.string().min(1, 'Le nom est requis').max(150),
  ville: z.string().max(150).optional().nullable(),
  type: salonTypeSchema.optional().nullable(),
  status: salonStatusSchema.default('Planifié'),
  startDate: z.coerce.date().optional().nullable(),
  endDate: z.coerce.date().optional().nullable(),
  
  // Game Config
  lot1Qty: z.number().int().min(0).default(0),
  lot1WinPercent: z.number().int().min(0).max(100).default(0),
  lot1Remaining: z.number().int().min(0).optional(),
  lot2Qty: z.number().int().min(0).default(0),
  lot2WinPercent: z.number().int().min(0).max(100).default(0),
  lot2Remaining: z.number().int().min(0).optional(),
  
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type Salon = z.infer<typeof salonSchema>;

export const createSalonSchema = salonSchema.omit({ 
  id: true, 
  slotNumber: true,
  createdAt: true, 
  updatedAt: true,
  lot1Remaining: true,
  lot2Remaining: true
}).extend({
  type: salonTypeSchema,
  startDate: z.coerce.date({
    error: 'La date de début est requise',
  }),
  endDate: z.coerce.date({
    error: 'La date de fin est requise',
  }),
});

export const updateSalonSchema = salonSchema.partial().omit({
  id: true,
  regionId: true,
  slotNumber: true,
  createdAt: true,
  updatedAt: true
});
